import React, { useState, useEffect } from "react";
import { Drawer } from "antd";
import Configuration from "../../assetConfig/configuration";
import { getInventoryResource } from "../../../../../redux/actions/inventoryActions";
import { getDeletedConfig } from "../../../../../redux/actions/historyActions";
import { useDispatch } from "react-redux";
import isEmpty from "lodash/isEmpty";

const RelationshipAssetConfig = ({ visible, onClose, row }) => {
  const dispatch = useDispatch();
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [code, setCode] = useState(null);

  useEffect(() => {
    if (row) {
      handleFetchConfiguration();
    }
  }, [row]);

  const handleFetchConfiguration = async () => {
    if (!isEmpty(row?.inventoryItem)) {
      setCode(row?.inventoryItem);
      return setLoadingConfig(false);
    }
    setLoadingConfig(true);

    // fetch configuration for deleted assets
    if (row?.state === "deleted") {
      if (isEmpty(row?.metadata) || row?.metadata === "deleted") {
        const deletedConfig = await dispatch(
          getDeletedConfig(row?.frn, row?.assetType)
        );
        setCode(deletedConfig);
        return setLoadingConfig(false);
      }
      setCode(row?.metadata);
      return setLoadingConfig(false);
    }

    //  live assets configurations
    const req = await dispatch(
      getInventoryResource(
        [row?.arn],
        [row?.assetType],
        "inv",
        null,
        null,
        true
      )
    );
    setCode(isEmpty(req?.responseObjects) ? {} : req.responseObjects[0]?.inventoryItem);
    setLoadingConfig(false);
  };

  return (
    <Drawer
      title={<div className="bold">{row?.name}</div>}
      placement="right"
      onClose={onClose}
      visible={visible}
      getContainer={false}
      style={{ position: "absolute" }}
      className="RelationshipAssetConfig"
      width={700}
    >
      <Configuration item={code} loading={loadingConfig} />
    </Drawer>
  );
};

export default RelationshipAssetConfig;
